import SnackbarMessage from "@/components/SnackbarMessage/SnackbarMessage.vue";

const client_app = process.env.VUE_APP_CLIENT_APP;

export default {
  name: "ResetPassword",
  components: {
    SnackbarMessage
  },

  data() {
    return ({
      email: "",
      is_loading: false,
      error_message: "",
      success_message: "",
      snackbar_timeout_id: null,
    });
  },

  beforeUnmount() {
    this.clear_snackbar_timer();
  },

  methods: {
    clear_snackbar_timer() {
      if (this.snackbar_timeout_id) {
        clearTimeout(this.snackbar_timeout_id);
        this.snackbar_timeout_id = null;
      }
    },

    start_snackbar_timer() {
      this.clear_snackbar_timer();
      this.snackbar_timeout_id = setTimeout(() => {
        this.error_message = "";
        this.success_message = "";
        this.snackbar_timeout_id = null;
      }, 5000);
    },

    clear_error_message() {
      this.clear_snackbar_timer();
      this.error_message = "";
    },

    clear_success_message() {
      this.clear_snackbar_timer();
      this.success_message = "";
    },

    set_error_message(message) {
      this.error_message = message || "Unable to send reset link. Please try again.";
      this.success_message = "";
      this.start_snackbar_timer();
    },

    set_success_message(message) {
      this.success_message = message || "Reset Password Link Sent";
      this.error_message = "";
      this.start_snackbar_timer();
    },

    async handleReset() {
      const RESET_PASSWORD_URL = process.env.VUE_APP_RESET_PASSWORD
      this.error_message = "";
      this.success_message = "";
      this.is_loading = true;

      try {
        // API CALL EXAMPLE (replace with your actual endpoint)
        const response = await fetch(RESET_PASSWORD_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: this.email, client_app }),
        })

        //When the reset password is success 
        const data = await response.json();
        this.set_success_message(data.message);
      } catch (error) {
        this.set_error_message("Unable to send reset link. Please try again.");
      } finally {
        this.is_loading = false;
      }
    }
  }
};
